(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["1-skt-product-block-bundle-product"] && !Shopify.designMode) return;
  try {
    if (!window.crosightBundleControlsReady) {
    window.crosightBundleControlsReady = true;
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') document.querySelectorAll('.skt-bundle-card details[open]').forEach(details => {details.open = false;});
    });
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      document.querySelectorAll('.skt-bundle-card details[open]').forEach(details => {
        if (!details.contains(event.target)) details.open = false;
      });
      const more = event.target.closest('.skt-bundle-card .skt-multiple-more');
      if (more) {
        event.preventDefault();
        const list = more.closest('.skt-bundle-card').querySelector('.skt-bundle-list');
        if (!list) return;
        const expanded = list.classList.toggle('skt-expanded');
        more.classList.toggle('skt-active', expanded);
        more.setAttribute('aria-expanded', String(expanded));
        return;
      }
      const variant = event.target.closest('.skt-bundle-card .skt-bundle-variant-button');
      if (!variant || variant.disabled) return;
      event.preventDefault();
      const item = variant.closest('.skt-bundle-item');
      const checkbox = item?.querySelector('input[type="checkbox"]');
      const title = item?.querySelector('[id^="skt-variant-title-"]');
      if (checkbox) checkbox.dataset.skuId = variant.dataset.variantId;
      if (title) title.textContent = variant.dataset.value;
      if (!item.querySelector('.skt-price[data-custom-price]')) {
        const price = item.querySelector('[data-bundle-price]');
        const compare = item.querySelector('[data-bundle-compare-price]');
        if (price) {price.textContent = variant.dataset.price;price.classList.toggle('skt-sale',Boolean(variant.dataset.comparePrice));}
        if (compare) {compare.textContent = variant.dataset.comparePrice;compare.hidden = !variant.dataset.comparePrice;}
      }
      const details = variant.closest('details');
      if (details) details.open = false;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.__crosightPurchaseControlsInstalled) return;
  window.__crosightPurchaseControlsInstalled = true;

  var pendingForms = new WeakSet();
  var pendingById = new Map();
  var confirmedSelections = new Map();
  var uncertainSelections = new Set();
  var purchaseSelector = 'form[data-crosight-purchase]';
  var paymentSelector = '.shopify-payment-button, shopify-accelerated-checkout';

  if (!window.customElements.get('crosight-protection-status')) {
    window.customElements.define('crosight-protection-status', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.product-info') || this.parentElement;
        this.delayed = false;
        this.message = this.querySelector('[role="status"]');
        this.reload = this.querySelector('button');
        this.reload.onclick = function () { window.location.reload(); };
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        this.timer = window.setTimeout(() => { this.delayed = true; this.update(); }, 15000);
        this.update();
      }
      update() {
        const cards = Array.from(this.scope.querySelectorAll('.xcotton-productProtection-detail-content-item'));
        this.hidden = cards.some(card => card.getClientRects().length > 0);
        const text = this.getAttribute(this.delayed ? 'data-delayed' : 'data-loading');
        if (this.message.textContent !== text) this.message.textContent = text;
        this.reload.hidden = !this.delayed;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.clearTimeout(this.timer);
      }
    });
  }

  function currentForm(form) {
    if (form.isConnected) return form;
    var replacement = document.getElementById(form.getAttribute('id'));
    return replacement && replacement.matches(purchaseSelector) ? replacement : form;
  }

  function controlsFor(form) {
    return currentForm(form).querySelector('buy-buttons.crosight-purchase-buttons');
  }

  function label(controls, name, fallback) {
    return controls && controls.getAttribute('data-' + name) || fallback;
  }

  function cartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + 'cart';
  }

  function formKey(form) {
    return form.getAttribute('id') || form;
  }

  // Include the response body in the deadline; a fetch response alone is not completion.
  function requestJson(url, options) {
    var controller = new AbortController();
    var timeout;
    var request = (async function () {
      var response = await fetch(url, Object.assign({}, options, { signal: controller.signal }));
      var data;
      try { data = await response.json(); }
      catch (error) { if (response.ok) throw error; data = {}; }
      return { response: response, data: data };
    })();
    var deadline = new Promise(function (resolve, reject) {
      timeout = window.setTimeout(function () {
        reject(new Error('Cart request timed out'));
        controller.abort();
      }, 15000);
    });
    return Promise.race([request, deadline]).finally(function () { window.clearTimeout(timeout); });
  }

  function checkoutReady(form, directClick) {
    var controls = controlsFor(form);
    var embedded = Boolean(window.Shopify && window.Shopify.designMode) || window.top !== window.self;
    setBusy(form, false);
    setStatus(form, 'success', label(controls, embedded ? 'checkout-ready-editor' : 'checkout-ready',
      embedded ? 'Items added. Open checkout in a new tab.' : 'Your items are ready for checkout.'), false);
    var link = document.createElement('a');
    link.href = cartUrl().replace(/cart$/, 'checkout');
    link.className = 'crosight-checkout-link';
    link.textContent = label(controls, 'continue-checkout', 'Continue to checkout');
    if (embedded) { link.target = '_blank'; link.rel = 'noopener'; }
    var status = controls && controls.querySelector('.crosight-purchase-status');
    if (status) { status.appendChild(document.createTextNode(' ')); status.appendChild(link); }
    // An async frame escape is unreliable. The editor gets an explicit user-activated link.
    try {
      if (!embedded) window.location.assign(link.href);
      else if (directClick) link.click();
    } catch (error) {
      // Keep the ready state and link; adding again would duplicate a confirmed purchase.
    }
  }

  function submitButtons(form) {
    return Array.from(form.elements).filter(function (element) {
      return element.type === 'submit' && !element.closest(paymentSelector);
    });
  }

  function setBusy(form, busy) {
    var forms = new Set([form, currentForm(form)]);
    forms.forEach(function (item) {
      submitButtons(item).forEach(function (button) {
        if (busy) {
          if (button.getAttribute('aria-busy') !== 'true') button.setAttribute('aria-busy', 'true');
        } else button.removeAttribute('aria-busy');
      });
    });
  }

  function setStatus(form, state, message, viewCart) {
    var controls = controlsFor(form);
    if (!controls) return;
    controls.setAttribute('data-crosight-state', state);
    var status = controls.querySelector('.crosight-purchase-status');
    if (!status) return;
    status.textContent = message;
    if (viewCart) {
      status.appendChild(document.createTextNode(' '));
      var link = document.createElement('a');
      link.href = cartUrl();
      link.textContent = label(controls, 'view-cart', 'View cart');
      status.appendChild(link);
    }
  }

  function emitError(form, message) {
    var safeText = document.createElement('span');
    safeText.textContent = message;
    currentForm(form).dispatchEvent(new CustomEvent('cart:error', {
      bubbles: true,
      detail: { error: safeText.innerHTML }
    }));
  }

  function errorDescription(response, fallback) {
    if (typeof response.description === 'string') return response.description;
    if (typeof response.message === 'string') return response.message;
    if (typeof response.errors === 'string') return response.errors;
    if (response.errors && typeof response.errors === 'object') {
      return Object.values(response.errors).flat().filter(function (value) {
        return typeof value === 'string';
      }).join(' ') || fallback;
    }
    return fallback;
  }

  function protectionError() {
    var error = new Error('Selected protection could not be confirmed');
    error.crosightProtection = true;
    return error;
  }

  function selectedProtectionId(form) {
    var activeForm = currentForm(form);
    var scope = activeForm.closest('.product-info') || activeForm.closest('.shopify-section') || activeForm;
    var card = scope.querySelector('.xcotton-productProtection-detail-content-item.xcotton-productProtection-detail-checked[data-id]');
    return card ? String(card.getAttribute('data-id') || '') : '';
  }

  async function selectedProtection(form) {
    var api = window.XCOTTON && window.XCOTTON.api;
    var fields = new FormData(currentForm(form));
    var mainId = String(fields.get('id') || '');
    // Xcotton updates its checked card before its asynchronous hidden field.
    var selectedId = selectedProtectionId(form);
    if (!api || typeof api.getSelectPPItem !== 'function') {
      if (selectedId || fields.get('properties[_PlanID]')) throw protectionError();
      return null;
    }
    if (!selectedId) return null;
    var timer;
    try {
      var plan = await Promise.race([
        api.getSelectPPItem(),
        new Promise(function (resolve, reject) {
          timer = window.setTimeout(function () { reject(protectionError()); }, 3000);
        })
      ]);
      if (!plan || String(plan.variantId) !== selectedId || !plan.properties ||
          !plan.properties['Plan ID'] || String(plan.properties.Reference) !== mainId ||
          selectedProtectionId(form) !== selectedId ||
          String(new FormData(currentForm(form)).get('id') || '') !== mainId) throw protectionError();
      return { variantId: String(plan.variantId), properties: Object.assign({}, plan.properties) };
    } catch (error) {
      throw protectionError();
    } finally {
      window.clearTimeout(timer);
    }
  }

  function assertProtectionCart(cart, payload) {
    if (!payload.protection) return;
    var plan = payload.protection;
    var rows = Array.isArray(cart.items) ? cart.items : [];
    var mainQuantity = rows.filter(function (item) {
      return String(item.variant_id || item.id) === payload.mainId && item.properties &&
        String(item.properties._PlanID) === String(plan.properties['Plan ID']);
    }).reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
    var protectionQuantity = rows.filter(function (item) {
      return String(item.variant_id || item.id) === plan.variantId && item.properties &&
        Object.keys(plan.properties).every(function (key) {
          return String(item.properties[key]) === String(plan.properties[key]);
        });
    }).reduce(function (total, item) { return total + Number(item.quantity || 0); }, 0);
    if (mainQuantity < payload.mainQuantity || protectionQuantity < mainQuantity) throw protectionError();
  }

  async function confirmedCart(payload) {
    var refreshed = await requestJson(cartUrl() + '.js?_xcotton=1', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store'
    });
    if (!refreshed.response.ok || !Array.isArray(refreshed.data.items)) throw new Error('Cart refresh failed');
    assertProtectionCart(refreshed.data, payload);
    return refreshed.data;
  }

  function payloadFor(form, checkout, protection) {
    var body = new FormData(form);
    Array.from(body.keys()).forEach(function (name) {
      if (/^(?:properties\[_PlanID\]|items\[\d+\]\[properties\]\[_PlanID\])$/.test(name)) body.delete(name);
    });
    if (protection) body.set('properties[_PlanID]', protection.properties['Plan ID']);
    var mainId = String(body.get('id') || '');
    var mainQuantity = Number(body.get('quantity') || 1);
    if (!body.has('quantity')) body.set('quantity', String(mainQuantity));
    if (!mainId) throw new Error('Missing selected variant');
    var productInfo = form.closest('.product-info');
    var accessoryInputs = productInfo ? productInfo.querySelectorAll(
      '.skt-bundle-card input[type="checkbox"]:checked:not(:disabled)'
    ) : [];
    var accessoryIds = Array.from(accessoryInputs).map(function (input) {
      return input.getAttribute('data-sku-id');
    }).filter(Boolean);

    var protectionPrefix = 'items[' + (accessoryIds.length + 1) + ']';
    if (accessoryIds.length || protection) {
      var lineFields = Array.from(body.keys()).filter(function (name) {
        return name === 'id' || name === 'quantity' || name === 'selling_plan' || name.indexOf('properties[') === 0;
      });
      new Set(lineFields).forEach(function (name) {
        var itemName = name.indexOf('properties[') === 0 ?
          'items[0][properties]' + name.slice('properties'.length) : 'items[0][' + name + ']';
        body.getAll(name).forEach(function (value) { body.append(itemName, value); });
        body.delete(name);
      });
      if (!body.has('items[0][quantity]')) body.set('items[0][quantity]', '1');
      accessoryIds.forEach(function (id, index) {
        body.append('items[' + (index + 1) + '][id]', id);
        body.append('items[' + (index + 1) + '][quantity]', '1');
      });
      if (protection) {
        body.append(protectionPrefix + '[id]', protection.variantId);
        body.append(protectionPrefix + '[quantity]', String(mainQuantity));
        Object.keys(protection.properties).forEach(function (key) {
          body.append(protectionPrefix + '[properties][' + key + ']', String(protection.properties[key]));
        });
      }
    }

    var selection = Array.from(body.entries()).filter(function (entry) {
      return entry[0] === 'id' || entry[0] === 'quantity' || entry[0] === 'selling_plan' ||
        entry[0].indexOf('properties[') === 0 || entry[0].indexOf('items[') === 0;
    }).map(function (entry) {
      var value = entry[1];
      return [entry[0], typeof value === 'string' ? value : [value.name, value.size, value.lastModified]];
    });
    selection.sort(function (a, b) { return a[0].localeCompare(b[0]); });
    selection = selection.filter(function (entry) {
      return !/^(?:properties\[_PlanID\]|items\[\d+\]\[properties\]\[_PlanID\])$/.test(entry[0]) || Boolean(entry[1]);
    });
    var signature = JSON.stringify(selection);
    var uncertaintySignature = JSON.stringify(selection.filter(function (entry) {
      return !(protection && entry[0].indexOf(protectionPrefix + '[') === 0) &&
        !/^(?:properties\[_PlanID\]|items\[\d+\]\[properties\]\[_PlanID\])$/.test(entry[0]);
    }).map(function (entry) {
      // Keep the same retry guard whether the main item used a single or a batch payload.
      return [entry[0].replace(/^items\[0\]\[properties\]/, 'properties').replace(/^items\[0\]\[(id|quantity|selling_plan)\]$/, '$1'), entry[1]];
    }).sort(function (a, b) {
      return a[0].localeCompare(b[0]);
    }));

    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));
    sections = Array.from(new Set(sections));
    if (!checkout) {
      body.set('sections', sections.join(','));
      body.set('sections_url', cartUrl().replace(/cart$/, 'variants/') + encodeURIComponent(mainId));
    } else {
      body.delete('sections');
      body.delete('sections_url');
    }
    return { body: body, sections: sections, signature: signature, uncertaintySignature: uncertaintySignature,
      protection: protection, mainId: mainId, mainQuantity: mainQuantity };
  }

  async function addItems(form, pending) {
    var controls = controlsFor(form);
    var uncertainMessage = label(controls, 'error', 'We could not confirm the cart update. Check your cart before trying again.');
    var confirmedAdded = false;
    var requestStarted = false;
    var rejected = false;
    var payload;

    try {
      setStatus(form, 'loading', label(controls, 'adding', 'Adding…'), false);
      setBusy(form, true);
      var protection = await selectedProtection(form);
      payload = payloadFor(currentForm(form), pending.checkout, protection);
      if (uncertainSelections.has(payload.uncertaintySignature)) {
        setStatus(form, 'error', uncertainMessage, true);
        return;
      }
      if (pending.checkout && confirmedSelections.get(formKey(form)) === payload.signature) {
        if (payload.protection) await confirmedCart(payload);
        checkoutReady(form, true);
        return;
      }
      setStatus(form, 'loading', label(controls, 'adding', 'Adding…'), false);
      setBusy(form, true);
      requestStarted = true;
      // Batch the selected plan with the vehicle; bypass only Xcotton's duplicate follow-up add.
      var added = await requestJson(cartUrl() + '/add.js' + (pending.checkout || protection ? '?_xcotton=1' : ''), {
        method: 'POST',
        body: payload.body,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      var response = added.response;
      var result = added.data;
      if (!response.ok || Number(result.status) >= 400 || result.errors) {
        rejected = true;
        var rejectedMessage = errorDescription(result, response.statusText || 'Unable to add items to cart.');
        setStatus(form, 'error', rejectedMessage, true);
        emitError(form, rejectedMessage);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      var items = Array.isArray(result.items) ? result.items : result.id ? [result] : [];
      if (!items.length) throw new Error('Unrecognized add response');
      confirmedAdded = true;
      confirmedSelections.set(formKey(form), payload.signature);
      var protectedCart = payload.protection ? await confirmedCart(payload) : null;
      if (pending.checkout) {
        checkoutReady(form, false);
        return;
      }

      var settings = window.themeVariables && window.themeVariables.settings || {};
      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        setStatus(form, 'success', label(controls, 'added', 'Added to cart'), true);
        window.location.href = cartUrl();
        return;
      }

      var cart = protectedCart || await confirmedCart(payload);
      if (!result.sections || payload.sections.some(function (section) {
        return typeof result.sections[section] !== 'string';
      })) throw new Error('Cart sections unavailable');
      cart.sections = result.sections;

      setStatus(form, 'success', label(controls, 'added', 'Added to cart'), false);
      currentForm(form).dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: items, cart: cart }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cart }
      }));
    } catch (error) {
      if (error.crosightProtection || (payload && payload.protection && confirmedAdded)) {
        var protectionMessage = label(controls, 'protection-error', 'We could not confirm your selected protection. Please check your cart or select your protection again before checkout.');
        setStatus(form, 'error', protectionMessage, true);
        emitError(form, protectionMessage);
      } else if (confirmedAdded) {
        setStatus(form, 'success', label(controls, 'cart-updated', 'Added to cart.'), true);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else {
        if (requestStarted && !rejected && payload) uncertainSelections.add(payload.uncertaintySignature);
        var message = requestStarted ? uncertainMessage : label(controls, 'unavailable', 'Choose an available option and try again.');
        setStatus(form, 'error', message, requestStarted);
        emitError(form, message);
      }
    } finally {
      pendingForms.delete(form);
      if (!pending.id || pendingById.get(pending.id) === pending) {
        if (pending.id) pendingById.delete(pending.id);
        setBusy(form, false);
      }
    }
  }

  // A cart edit begins a new purchase attempt; do not reuse stale confirmed items.
  document.addEventListener('cart:change', function (event) {
    if (!event.detail || event.detail.baseEvent !== 'variant:add') confirmedSelections.clear();
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    confirmedSelections.clear();
    document.querySelectorAll(purchaseSelector).forEach(function (form) {
      if (!pendingById.has(form.getAttribute('id'))) setBusy(form, false);
    });
  });

  document.addEventListener('product:rerender', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(purchaseSelector)) return;
    var pending = pendingById.get(form.getAttribute('id'));
    if (!pending) return;
    queueMicrotask(function () {
      if (pendingById.get(pending.id) !== pending) return;
      var controls = controlsFor(pending.form);
      setStatus(pending.form, 'loading', label(controls, 'adding', 'Adding…'), false);
      setBusy(pending.form, true);
    });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(purchaseSelector) || !controlsFor(form)) return;
    var submitter = event.submitter;
    if (submitter && (submitter.closest(paymentSelector) || submitter.name === 'checkout')) return;
    if (submitter && !submitter.closest('.skt-main-product-buy-buttons, .crosight-buy-now, product-quick-add')) return;

    var wasPrevented = event.defaultPrevented;
    event.preventDefault();
    event.stopImmediatePropagation();
    var formId = form.getAttribute('id');
    if (wasPrevented || pendingForms.has(form) || formId && pendingById.has(formId)) return;
    if (submitter && submitter.matches(':disabled')) return;
    if (!submitter && submitButtons(form).every(function (button) { return button.matches(':disabled'); })) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    pendingForms.add(form);
    var pending = { id: formId, form: form, checkout: Boolean(submitter && submitter.name === 'crosight_checkout') };
    if (formId) pendingById.set(formId, pending);
    addItems(form, pending);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crosight-trike-guide-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('crosight-trike-guide')) {
    class CrosightTrikeGuide extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;

        this._initialized = true;
        this._dialog = this.querySelector('[data-crosight-guide-dialog]');
        this._closeButton = this.querySelector('[data-crosight-guide-close]');
        this._scroll = this.querySelector('[data-crosight-guide-scroll]');
        this._abortController = new AbortController();

        if (!this._dialog) return;

        const signal = this._abortController.signal;

        document.addEventListener('click', (event) => this._handleDocumentClick(event), { signal });
        this._dialog.addEventListener('click', (event) => this._handleDialogClick(event), { signal });
        this._dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        }, { signal });
        this._dialog.addEventListener('close', () => this._handleClosed(), { signal });
        this._closeButton?.addEventListener('click', () => this.close(), { signal });
      }

      disconnectedCallback() {
        this._abortController?.abort();
        if (this._dialog?.open) this._dialog.close();
        this._initialized = false;
      }

      _handleDocumentClick(event) {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-crosight-guide-open]');
        if (trigger) {
          event.preventDefault();
          event.stopPropagation();
          this.open(trigger);
          return;
        }

        const tab = event.target.closest('[data-crosight-guide-tab]');
        if (tab && this._dialog.contains(tab)) {
          this._selectTab(tab.dataset.crosightGuideTab);
        }
      }

      _handleDialogClick(event) {
        if (event.target !== this._dialog) return;

        const rect = this._dialog.getBoundingClientRect();
        const isOutside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (isOutside) this.close();
      }

      open(trigger) {
        if (this._dialog.open) return;

        this._activeTrigger = trigger;
        document.querySelectorAll('[data-crosight-guide-open]').forEach((button) => {
          button.setAttribute('aria-expanded', String(button === trigger));
        });
        this._dialog.showModal();
        if (this._scroll) this._scroll.scrollTop = 0;
        requestAnimationFrame(() => this._closeButton?.focus({ preventScroll: true }));
      }

      close() {
        if (!this._dialog.open) return;

        this._dialog.close();
      }

      _handleClosed() {
        document.querySelectorAll('[data-crosight-guide-open]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        if (this._activeTrigger?.isConnected && this._activeTrigger.getClientRects().length) {
          this._activeTrigger.focus({ preventScroll: true });
        }
      }

      _selectTab(tabName) {
        if (!tabName) return;

        this.querySelectorAll('[data-crosight-guide-tab]').forEach((tab) => {
          const isSelected = tab.dataset.crosightGuideTab === tabName;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.querySelectorAll('[data-crosight-guide-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.crosightGuidePanel !== tabName;
        });

        if (this._scroll) this._scroll.scrollTop = 0;
      }
    }

    customElements.define('crosight-trike-guide', CrosightTrikeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('crosight-review-summary')) {
    class CroSightReviewSummary extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
        this._button = this.querySelector('[data-review-trigger]');
        this._popover = this.querySelector('[data-review-popover]');
        this._closeButton = this.querySelector('[data-review-close]');
        this._relatedToggle = this.querySelector('[data-related-stores-toggle]');
        this._relatedPanel = this.querySelector('[data-related-stores-panel]');
        this._variantText = this.querySelector('[data-review-variant]');
        this._variants = this._parseVariants();
        this._scope = this.closest('product-card, .custom-product-card, .product-info') || this.parentElement;
        this._abortController = new AbortController();
        this._closeTimer = null;

        if (!this._button || !this._popover) return;

        const signal = this._abortController.signal;
        const panelId = `crosight-review-popover-${CroSightReviewSummary.nextId++}`;
        this._popover.id = panelId;
        this._button.setAttribute('aria-controls', panelId);

        if (this._relatedToggle && this._relatedPanel) {
          const relatedPanelId = `${panelId}-related-stores`;
          this._relatedPanel.id = relatedPanelId;
          this._relatedToggle.setAttribute('aria-controls', relatedPanelId);
          this._relatedToggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this._setRelatedExpanded(this._relatedToggle.getAttribute('aria-expanded') !== 'true');
          }, { signal });
        }

        this._button.addEventListener('pointerdown', () => {
          this._wasOpenOnPointerDown = this._popover.matches(':popover-open');
        }, { signal });

        this._button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const wasOpen = this._popover.matches(':popover-open') || this._wasOpenOnPointerDown;
          this._wasOpenOnPointerDown = false;

          if (isMobile && wasOpen) {
            this.close(true);
          } else {
            this.open(true);
          }
        }, { signal });

        this._closeButton?.addEventListener('click', () => this.close(true), { signal });
        this._popover.addEventListener('toggle', () => this._syncOpenState(), { signal });

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.addEventListener('pointerenter', () => this.open(), { signal });
          this.addEventListener('pointerleave', () => this._scheduleClose(), { signal });
          this._popover.addEventListener('pointerenter', () => this._cancelClose(), { signal });
          this._popover.addEventListener('pointerleave', () => this._scheduleClose(), { signal });
        }

        this._scope?.addEventListener('change', () => this._scheduleVariantUpdate(), { signal });
        this._scope?.addEventListener('click', () => this._scheduleVariantUpdate(), { signal });
        if (this._scope) {
          this._variantObserver = new MutationObserver(() => this._scheduleVariantUpdate());
          this._scope
            .querySelectorAll('[data-option-position][data-variant-option-value], input[data-option-position], input[name="id"]')
            .forEach((control) => {
              this._variantObserver.observe(control, {
                attributes: true,
                attributeFilter: ['class', 'checked', 'value']
              });
          });
        }
        window.addEventListener('resize', () => this._position(), { signal, passive: true });
        window.addEventListener('scroll', () => this._position(), { signal, passive: true });
        this._updateVariant();
      }

      disconnectedCallback() {
        this._abortController?.abort();
        this._variantObserver?.disconnect();
        window.clearTimeout(this._variantUpdateTimer);
        this._cancelClose();
        this._initialized = false;
      }

      open(focusPanel = false) {
        this._cancelClose();
        if (!this._popover.matches(':popover-open')) {
          this._popover.showPopover();
        }
        this.setAttribute('open', '');
        this._button.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => {
          this._position();
          if (focusPanel) this._closeButton?.focus({ preventScroll: true });
        });
      }

      close(restoreFocus = false) {
        this._cancelClose();
        if (this._popover.matches(':popover-open')) {
          this._popover.hidePopover();
        }
        this.removeAttribute('open');
        this._button.setAttribute('aria-expanded', 'false');
        this._setRelatedExpanded(false);
        if (restoreFocus) this._button.focus({ preventScroll: true });
      }

      _setRelatedExpanded(expanded) {
        if (!this._relatedToggle || !this._relatedPanel) return;
        this._relatedToggle.setAttribute('aria-expanded', String(expanded));
        this._relatedPanel.hidden = !expanded;
      }

      _syncOpenState() {
        const isOpen = this._popover.matches(':popover-open');
        this.toggleAttribute('open', isOpen);
        this._button.setAttribute('aria-expanded', String(isOpen));
        if (!isOpen) this._setRelatedExpanded(false);
      }

      _scheduleClose() {
        this._cancelClose();
        this._closeTimer = window.setTimeout(() => this.close(), 180);
      }

      _cancelClose() {
        if (this._closeTimer) {
          window.clearTimeout(this._closeTimer);
          this._closeTimer = null;
        }
      }

      _position() {
        if (!this.hasAttribute('open') || window.matchMedia('(max-width: 749px)').matches) return;
        const triggerRect = this._button.getBoundingClientRect();
        const panelRect = this._popover.getBoundingClientRect();
        const gap = 8;
        const edge = 12;
        let left = triggerRect.left;
        let top = triggerRect.bottom + gap;

        left = Math.min(left, window.innerWidth - panelRect.width - edge);
        left = Math.max(edge, left);

        if (top + panelRect.height > window.innerHeight - edge) {
          top = triggerRect.top - panelRect.height - gap;
        }

        top = Math.max(edge, top);
        this._popover.style.left = `${Math.round(left)}px`;
        this._popover.style.top = `${Math.round(top)}px`;
      }

      _parseVariants() {
        const script = this.querySelector('[data-review-variants]');
        try {
          return script ? JSON.parse(script.textContent || '[]') : [];
        } catch (error) {
          return [];
        }
      }

      _scheduleVariantUpdate() {
        window.clearTimeout(this._variantUpdateTimer);
        this._variantUpdateTimer = window.setTimeout(() => this._updateVariant(), 80);
      }

      _updateVariant() {
        if (!this._variantText || !this._scope) return;
        const variant = this._findSelectedVariant();
        const fallback = this.dataset.initialVariant || '';
        const label = variant?.public_title || variant?.title || fallback;
        const normalized = label === 'Default Title' ? '' : label;

        if (normalized) {
          this._variantText.textContent = normalized;
          this._variantText.hidden = false;
        } else {
          this._variantText.hidden = true;
        }
      }

      _findSelectedVariant() {
        if (!this._variants.length) return null;

        const initialVariant = this._variants.find(
          (variant) => String(variant.id) === String(this.dataset.initialVariantId || '')
        ) || null;
        const selections = new Map();
        this._scope.querySelectorAll('[data-option-position][data-variant-option-value].is-active').forEach((control) => {
          selections.set(Number(control.dataset.optionPosition), control.dataset.variantOptionValue || '');
        });
        this._scope.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
          const associatedLabel = input.id ? this._scope.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
          const value = input.dataset.optionValue || associatedLabel?.textContent?.trim() || input.value;
          selections.set(Number(input.dataset.optionPosition), value);
        });

        if (selections.size) {
          initialVariant?.options?.forEach((value, index) => {
            const position = index + 1;
            if (!selections.has(position)) selections.set(position, value);
          });
          const selectionMatch = this._variants.find((variant) => {
            return Array.from(selections.entries()).every(([position, value]) => {
              const optionValue = variant[`option${position}`] || variant.options?.[position - 1] || '';
              return this._normalize(optionValue) === this._normalize(value);
            });
          });
          if (selectionMatch) return selectionMatch;
        }

        const idInput = this._scope.querySelector('input[name="id"]');
        const idVariant = idInput
          ? this._variants.find((variant) => String(variant.id) === String(idInput.value)) || null
          : null;
        return idVariant || initialVariant;
      }

      _normalize(value) {
        return String(value || '').trim().toLowerCase();
      }
    }

    CroSightReviewSummary.nextId = 1;
    customElements.define('crosight-review-summary', CroSightReviewSummary);
  }
  } catch(e) { console.error(e); }
})();

})();
